import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getMyOrders } from "../api/order";
import { useAuth } from "../context/AuthContext";

const STATUS_LABEL = {
  PENDING: "결제대기", PAID: "결제완료", READY: "상품준비중", SHIPPING: "배송중",
  DELIVERED: "배송완료", CANCELLED: "취소", REFUNDED: "환불완료", FAILED: "결제실패",
};

export default function OrdersPage() {
  const { auth } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    getMyOrders(auth?.accessToken)
      .then((res) => setOrders(res.data || []))
      .catch((err) => setError(err.response?.data?.message || "주문내역을 불러오지 못했습니다."))
      .finally(() => setLoading(false));
  }, [auth]);

  return (
    <div className="page">
      <h1 className="page-title">주문내역</h1>
      {loading && <p className="text-sub">불러오는 중...</p>}
      {!loading && error && <p className="error">{error}</p>}
      {!loading && !error && orders.length === 0 && <p className="text-sub">주문 내역이 없습니다.</p>}

      <div className="reservation-list">
        {orders.map((o) => (
          <Link className="reservation-card" to={`/orders/${o.orderGroupId}`} key={o.orderGroupId}>
            <div className="reservation-card-top">
              <strong>주문번호 {o.orderGroupId}</strong>
              <span className={`status-tag status-${o.orderStatus === "PAID" ? "CONFIRMED" : o.orderStatus === "FAILED" || o.orderStatus === "CANCELLED" ? "CANCELLED" : "REQUESTED"}`}>
                {STATUS_LABEL[o.orderStatus] || o.orderStatus}
              </span>
            </div>
            <div className="text-sub">{Number(o.totalAmount).toLocaleString()}원</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
